module.exports = __webpack_public_path__ + "img/sy-code.ed0be895.png";